import { Component, ChangeDetectorRef } from '@angular/core'
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular'

import { HousingUnit, Message, MessageReceiverType, DeviceType } from '../../models/models'

import { MessageProvider } from '../../providers/message/message'
import { CondominiumProvider } from '../../providers/condominium/condominium'
import { UserProvider } from '../../providers/user/user'
import { HousingUnitProvider } from '../../providers/housing-unit/housing-unit'

import { HousingUnitEditPage } from '../../pages/housing-unit-edit/housing-unit-edit'
import { HousingUnitUserCreatePage } from '../../pages/housing-unit-user-create/housing-unit-user-create'
import { AuthProvider } from '../../providers/auth/auth'
import { Paginator } from '../../models/interfaces'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-housing-unit-show',
	templateUrl: 'housing-unit-show.html',
})
export class HousingUnitShowPage {
	/**
	*/
	private _isDetailsExpanded: boolean = false;
	public get isDetailsExpanded(): boolean {
		return this._isDetailsExpanded
	};
	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	public set isDetailsExpanded(value: boolean) {
		this._isDetailsExpanded = value
		this.changeDetector.detectChanges()
	}


	/**
In fase di caricamento dati
*/
	public get isLoading(): boolean {
		return this._isLoading
	};
	public set isLoading(value: boolean) {
		this._isLoading = value
		this.changeDetector.detectChanges()
	}
	private _isLoading: boolean = true;

	/**
	Usato direttamente in HTML
	*/
	public get isMessagesExpanded(): boolean {
		return this._isMessagesExpanded
	};
	public set isMessagesExpanded(value: boolean) {
		this._isMessagesExpanded = value
		this.changeDetector.detectChanges()
	}
	private _isMessagesExpanded: boolean = true;

	/**
	Unità abitativa correntemente visualizzata
	*/
	public get housingUnit(): HousingUnit {
		return this._housingUnit
	};
	public set housingUnit(value: HousingUnit) {
		this._housingUnit = value
		this.changeDetector.detectChanges()
	}
	private _housingUnit: HousingUnit = undefined;

	public messagePaginator: Paginator<Message>

	public get canAddOwner() {
		return this.auth.canHousingUnitUserAdd(this.housingUnit)
	}

	public get canAddResident() {
		return this.auth.canHousingUnitUserAdd(this.housingUnit)
	}


	//cache
	private _isIntercomAvailable: boolean = null;
	/**
	Verifica se l'unità è associata ad un condominio con citofono
	*/
	public get isIntercomAvailable(): boolean {
		if(this._isIntercomAvailable !== null) {
			return this._isIntercomAvailable
		}
		return this._isIntercomAvailable = (this.housingUnit.condominium
			&& this.housingUnit.condominium.devices
			&& (this.housingUnit.condominium.devices.filter((d) => { return d.type === DeviceType.INTERCOM }).length > 0)
		)
	}

	public get isResident() {
		return this.auth.hasHousingUnitRole(this.housingUnit, 'is_resident')
	}


	public get isOwner(): boolean {
		return this.auth.hasHousingUnitRole(this.housingUnit, 'is_owner')
	};


	constructor(
		public alertCtrl: AlertController,
		public auth: AuthProvider,
		private changeDetector: ChangeDetectorRef,
		public navCtrl: NavController,
		public navParams: NavParams,
		public condominiums: CondominiumProvider,
		public messages: MessageProvider,
		public housingUnits: HousingUnitProvider,
		public toastCtrl: ToastController,
		public users: UserProvider
	) {
		//NOTE avviare il refresh, attraverso il setter, nel costruttore inibisce la visualizzazione della pagina
		this._housingUnit = navParams.get('housingUnit')
	}

	goToHousingUnitEdit(housingUnit: HousingUnit) {
		this.navCtrl.push(HousingUnitEditPage, { housingUnit: housingUnit })
	}

	goToHousingUnitUserAdd(housingUnit, role) {
		this.navCtrl.push(HousingUnitUserCreatePage, {
			housingUnit: housingUnit,
			is_resident: role == 'is_resident',
			is_owner: role == 'is_owner',
			generatePin: true
		})
	}

	ionViewWillEnter() {
		this.refresh()
	}

	refresh() {
		let self = this

		this.isLoading = true
		/*
		WARN Cambiando l'ordine l'eager loading smette di funzionare
		*/
		this.housingUnits.getById(this.housingUnit.id, [
			'intercomUser',
			'condominium',
			'condominium.userRoles',
			'condominium.devices',
			'condominium.housingUnits',
			'users.housingUnits.condominium.userRoles'
		]).then((housingUnit: HousingUnit) => {
			self.housingUnit = housingUnit
			self.isLoading = false//primo caricamento

			self.messagePaginator = {
				next(before: Message = null, pagesize: number = 10): Promise<Message[]> {
					console.debug('[HousingUnitShowPage.messagePaginator.next()] Richiesto il caricamento di ulteriori ' + pagesize + ' messaggi dall\' unità abitativa, a partire da:', before)

					return new Promise<Message[]>((resolve, reject) => {
						self.messages.indexIncoming(
							self.housingUnit.id,
							MessageReceiverType.HOUSING_UNIT,
							['condominium', 'condominium.userRoles', 'device', 'device.condominium', 'housingUnit', 'housingUnit.userRoles', 'sender', 'receiver'],
							pagesize,
							before
						).then(
							(messages: Message[]) => {
								console.log('Recuperati altri messaggi per l\' unità abitativa: ', messages)

								resolve(messages)
								this.changeDetector.detectChanges()
							},
							(error) => {
								console.error("Errore recuperando i messaggi per l\' unità abitativa:", error)
								reject(error)
							}
						)
					})
				}
			}

			this.changeDetector.detectChanges()
		}).catch(error => {
			self.isLoading = false
			console.error("Errore recuperando l\'unità immobliare:", error)
		})
	}
}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-show/housing-unit-show.ts